module.exports = __webpack_public_path__ + "img/ic_console_hanging.3c567c8e.svg";